<template>
  <v-form ref="form" v-model="isValid" class="container">
    <!-- KAA Involvement -->
    <v-alert
      v-model="alert"
      border="start"
      close-label="Close"
      color="red accent-4"
      title="Are you involved in Kallamino Alumni Association (KAA) activities?"
      variant="tonal"
    ></v-alert>

    <v-radio-group v-model="alumniInvolvement.isInvolvedInKAA" class="custom-switch" mandatory>
      <v-radio label="Yes" :value="true" :color="alumniInvolvement.isInvolvedInKAA === true ? 'success' : ''"></v-radio>
      <v-radio label="No" :value="false" :color="alumniInvolvement.isInvolvedInKAA === false ? 'error' : ''"></v-radio>
    </v-radio-group>
    
    <v-select
      v-if="alumniInvolvement.isInvolvedInKAA"
      label="Your Involvement in Kelamino Alumni Association"
      v-model="alumniInvolvement.involvementInKAA"
      :items="['As management', 'As member']"
      :rules="[rules.required]"
      variant="outlined"
      dense
      class="form-field mb-8"
      color="blue"
      hide-details="auto"
    >
      <template v-slot:prepend>
        <v-icon color="red">mdi-school</v-icon>
      </template>
    </v-select>

    <v-divider></v-divider>

    <!-- KSHS Involvement -->
    <v-alert
      v-model="alert"
      border="start"
      close-label="Close"
      color="red accent-4"
      title="Are you involved in Kallamino Special High School activities?"
      variant="tonal"
    ></v-alert>

    <v-radio-group v-model="alumniInvolvement.isInvolvedInKSHS" class="custom-switch" mandatory>
      <v-radio label="Yes" :value="true" :color="alumniInvolvement.isInvolvedInKSHS === true ? 'success' : ''"></v-radio>
      <v-radio label="No" :value="false" :color="alumniInvolvement.isInvolvedInKSHS === false ? 'error' : ''"></v-radio>
    </v-radio-group>
    
    <v-select
      v-if="alumniInvolvement.isInvolvedInKSHS"
      label="Your Involvement in KSHS"
      v-model="alumniInvolvement.involvementInKSHS"
      :items="['Donation', 'Mentorship', 'Voluntary service', 'Partnership', 'Other']"
      :rules="[rules.required]"
      variant="outlined"
      dense
      class="form-field mb-8"
      color="blue"
      hide-details="auto"
    >
      <template v-slot:prepend>
        <v-icon color="red">mdi-school</v-icon>
      </template>
    </v-select>

    <!-- Conditional text area for "Other (specify)" -->
    <v-text-field
      v-if="alumniInvolvement.involvementInKSHS === 'Other'"
      label="Please Specify Your Involvement"
      v-model="alumniInvolvement.specifyOther"
      :rules="[rules.required]"
      variant="outlined"
      dense
      class="form-field mb-8"
      color="blue"
      hide-details="auto"
    >
      <template v-slot:prepend>
        <v-icon color="red">mdi-comment-text-outline</v-icon>
      </template>
    </v-text-field>

    <v-alert
      v-model="alert"
      border="start"
      close-label="Close"
      color="red accent-4"
      title="What is your future plan of engagement in KSHS?"
      variant="tonal"
    ></v-alert>

    <!-- Future Plans -->
    <v-textarea
      label="Future Plans for KSHS"
      v-model="alumniInvolvement.futurePlanInKSHS"
      variant="outlined"
      dense
      class="form-field"
      color="red"
      hide-details="auto"
    >
      <template v-slot:prepend>
        <v-icon color="red">mdi-clipboard-text</v-icon>
      </template>
    </v-textarea>

    <!-- Submit Button -->
    <!-- <v-btn color="primary" @click="validateAndSubmit">Submit</v-btn> -->

    <!-- Snackbar for validation messages -->
    <v-snackbar v-model="snackbar" :timeout="3000" top>
      {{ snackbarMessage }}
    </v-snackbar>
  </v-form>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      alumniInvolvement: {
        isInvolvedInKAA: false,
        involvementInKAA: "",
        isInvolvedInKSHS: false,
        involvementInKSHS: "",
        specifyOther: "",
        futurePlanInKSHS: "",
      },
      isValid: false,
      snackbar: false,
      snackbarMessage: "",
      rules: {
        required: value => !!value || "This field is required.",
      },
    };
  },

  computed: {
    userInvolvment() {
      return this.$store.getters.user.alumniInvolvement || {
        isInvolvedInKAA: false,
        involvementInKAA: "",
        isInvolvedInKSHS: false,
        involvementInKSHS: "",
        specifyOther: "",
        futurePlanInKSHS: "",
      };
   },
  },
  mounted() {
    // Initialize personalInfo with the data from the computed property
    this.alumniInvolvement = { ...this.userInvolvment };
  },
  watch: {
    "alumniInvolvement.isInvolvedInKAA"(newVal) {
      if (!newVal && this.alumniInvolvement) {
        this.alumniInvolvement.involvementInKAA = "";
      }
    },
    "alumniInvolvement.isInvolvedInKSHS"(newVal) {
      if (!newVal && this.alumniInvolvement) {
        this.alumniInvolvement.involvementInKSHS = "";
        this.alumniInvolvement.specifyOther = "";
      }
    },
    alumniInvolvement: {
      handler(newData) {
        if (newData) {
          this.$emit("update-form-data", newData);
        }
      },
      deep: true,
    },
  },
  methods: {
    reset() {
      this.alumniInvolvement = {
        isInvolvedInKAA: false,
        involvementInKAA: "",
        isInvolvedInKSHS: false,
        involvementInKSHS: "",
        specifyOther: "",
        futurePlanInKSHS: "",
      };
    },

    async validateForm() {
    if (!this.alumniInvolvement) {
      console.error("alumniInvolvement is null or undefined");
      return false;
    }

    const isValid = await this.$refs.form.validate();
    console.log('Form validation:', isValid);
    this.formIsValid = isValid.valid;
    console.log(isValid.valid ? 'All fields are valid.' : 'Validation failed.');

    if (this.alumniInvolvement.isInvolvedInKAA === false && this.alumniInvolvement.isInvolvedInKSHS === false) {
      return true;
    }
    return isValid.valid;
  },
    // async validateForm() {
    //   const isValid = await this.$refs.form.validate();
    //   console.log('Form validation:', isValid);
    //   this.formIsValid = isValid.valid;
    //   console.log(isValid.valid ? 'All fields are valid.' : 'Validation failed.');
    //   if(this.isInvolvedInKAA ===false && this.isInvolvedInKSHS ===false)
    //       return true;
    //   return isValid.valid;   
    //   // return true;
    // },
    // async validateAndSubmit() {
    //   const isValid = await this.$refs.form.validate();
    //   if (isValid) {
    //     this.snackbarMessage = "Form is valid!";
    //   } else {
    //     this.snackbarMessage = "Please fill in all required fields.";
    //   }
    //   this.snackbar = true;
    //   return isValid;
    // },
  },
};
</script>

  <style scoped>
  .stylish-field {
  background-color: #f9f9f9;
  padding: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stylish-field:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 15px rgba(54, 202, 222, 0.4);
}

.country-select-field {
 

  border: 1px solid rgba(0, 0, 0, 0.397);
  border-radius: 3px;
  width: 100%;
  height: 40px;
  background: transparent;
  padding: 0;
  font-size: 1rem;
  color: #495057;
}



.container {
  max-width: 1000px;
  margin: 10px auto;
  padding: 10px;
  background: linear-gradient(135deg, #f0f4f8, #d9e2ec);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border: 1px solid #e1e7ef;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  position: relative;
}

.container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
  animation: rotate-bg 8s linear infinite;
  z-index: 0;
}

.container:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.container > * {
  position: relative;
  z-index: 1;
}

@keyframes rotate-bg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.form-field {
  /* margin-bottom: 20px; */
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(231, 183, 179, 0.778);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.form-field:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 15px rgba(109, 191, 46, 0.77);
}

.v-text-field input {
  font-size: 1rem;
  font-weight: 500;
}

.v-select .v-select__selections {
  font-size: 1rem;
  font-weight: 500;
}

.v-form .v-input__control {
  border-radius: 8px;
}

.v-text-field.v-text-field--outlined {
  background-color: #ffffff;
  border-radius: 12px;
}

.v-text-field .v-input__append-inner {
  padding-right: 15px;
}

.v-text-field .v-input__prepend-inner {
  padding-left: 15px;
}

.v-select {
  /* margin-top: 15px; */
}

.v-select .v-select__selections {
  font-size: 1rem;
  font-weight: 500;
}

.v-btn {
  background-color: #6200ea;
  color: white;
  padding: 12px 20px;
  border-radius: 50px;
  box-shadow: 0 4px 10px rgb(242, 12, 12);
  transition: background-color 0.3s ease;
}

.v-btn:hover {
  background-color: #3700b3;
} 

.red-icon {
  color: red !important;
}
  </style>
  